@let obs =
  {
    amountPayments: amountPayments$ | async,
    paymentsSchedule: paymentsSchedule$ | async,
  };

<div class="widget">
  <div class="btns">
    <button
      type="button"
      (click)="setAmountPayments(AmountPaymentsEnum.FourPayments)"
      [class]="obs.amountPayments === AmountPaymentsEnum.FourPayments ? 'active' : ''"
    >
      на 4 части
    </button>
    <button
      type="button"
      (click)="setAmountPayments(AmountPaymentsEnum.SixPayments)"
      [class]="obs.amountPayments === AmountPaymentsEnum.SixPayments ? 'active' : ''"
    >
      на 6 частей
    </button>
  </div>

  @if (obs.amountPayments === AmountPaymentsEnum.FourPayments) {
    <div class="payments">
      @for (paymentData of obs.paymentsSchedule?.paymentsDates; track paymentData) {
        <div class="payment">
          <div class="line"></div>
          <span>{{ paymentData }}</span>
          <div class="paymentSum">{{ obs.paymentsSchedule?.paymentSum }} ₽</div>
        </div>
      }
    </div>
  } @else if (obs.amountPayments === AmountPaymentsEnum.SixPayments) {
    <div>
      <div class="payments long">
        <div class="payment first">
          <div class="line"></div>
          <span>Сегодня</span>
          <div class="paymentSum">{{ obs.paymentsSchedule?.firstPayment }} ₽</div>
        </div>
        <div class="other-payments">
          <div class="payment">
            <div class="day-lines">
              @for (i of [].constructor(5); track i) {
                <div class="day-line"></div>
              }
            </div>
            <span>Еще 5 платежей раз в 2 недели</span>
            <div class="paymentSum">{{ obs.paymentsSchedule?.otherPayments }} ₽</div>
          </div>
        </div>
      </div>
      <p class="service-fee">возможен сервисный сбор</p>
    </div>
  }
  <div class="note">первый платеж сейчас, остальные - раз в 2 недели</div>
</div>
